/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanyLogoEntry } from './';
import {
    CompanyLogoEntryFromJSON,
    CompanyLogoEntryFromJSONTyped,
    CompanyLogoEntryToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyLogoEntriesPage
 */
export interface CompanyLogoEntriesPage {
    /**
     * 
     * @type {Array<CompanyLogoEntry>}
     * @memberof CompanyLogoEntriesPage
     */
    entries: Array<CompanyLogoEntry>;
    /**
     * 
     * @type {number}
     * @memberof CompanyLogoEntriesPage
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyLogoEntriesPage
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyLogoEntriesPage
     */
    size: number;
}

/**
 * Check if a given object implements the CompanyLogoEntriesPage interface.
 */
export function instanceOfCompanyLogoEntriesPage(value: object): value is CompanyLogoEntriesPage {
    if (!('entries' in value) || value['entries'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    return true;
}

export function CompanyLogoEntriesPageFromJSON(json: any): CompanyLogoEntriesPage {
    return CompanyLogoEntriesPageFromJSONTyped(json, false);
}

export function CompanyLogoEntriesPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyLogoEntriesPage {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(CompanyLogoEntryFromJSON)),
        'totalElements': json['totalElements'],
        'page': json['page'],
        'size': json['size'],
    };
}

export function CompanyLogoEntriesPageToJSON(value?: CompanyLogoEntriesPage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'entries': ((value['entries'] as Array<any>).map((v) => CompanyLogoEntryToJSON(v))),
        'totalElements': value['totalElements'],
        'page': value['page'],
        'size': value['size'],
    };
}

